export const SET_FEATURES = "SET_FEATURES";

export const WEB_EVENT_ICON = "web-event-icon";
export const WEB_NEW_FACETS = "web-plp-new-facets";
export const WEB_SHOW_DISCOUNT_LABEL = "plp-show-discount-label";
